"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var systemTab_1 = require("../../model/systemTab");
var service_1 = require("../../../library/base/service");
var Home = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Home, _super);
    function Home() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '首页标签';
        _this.code = '100003';
        _this.desc = "";
        _this.requestParams = new systemTab_1.HomeRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Home;
}(service_1.BaseService));
exports.Home = Home;
//# sourceMappingURL=home.js.map